<kd-slds-modal heading="Manage Credentials" [(open)]="modalOpen">
    <div class="body">
        <div class="loader">
            <kd-loader *ngIf="loader"></kd-loader>
        </div>

        <div class="slds-grid">
            <div class="data kd-grid">
                <div class="kd-col slds-size--1-of-2">
                    <div class="slds-form-element">
                        <div class="slds-form-element__label">Key</div>
                    </div>
                </div>

                <div class="kd-col slds-size--1-of-2">
                    <div class="slds-form-element">
                        <div class="slds-form-element__label">Value</div>
                    </div>
                </div>
            </div>

            <div class="actions slds-text-align--right"></div>
        </div>

        <div *ngFor="let credential of credentials" class="slds-grid">
            <div class="data kd-grid">
                <div class="kd-col slds-size--1-of-2">
                    <div class="slds-form-element">
                        <div class="slds-form-element__static">{{credential.key}}</div>
                    </div>
                </div>

                <div class="kd-col slds-size--1-of-2">
                    <div class="slds-form-element">
                        <input
                            class="slds-input"
                            type="text"
                            [(ngModel)]="credential.value"
                            (ngModelChange)="onUpdate(credential)"
                        />
                    </div>
                </div>
            </div>

            <div class="actions slds-text-align--right">
                <button class="slds-button" (click)="remove(credential)">
                    <svg class="slds-button__icon" kdSldsIcon="delete"></svg>
                </button>
            </div>
        </div>

        <div *ngIf="options.length" class="slds-grid slds-m-bottom--small">
            <div class="data kd-grid">
                <div class="kd-col slds-size--1-of-2">
                    <div class="slds-select_container">
                        <select
                            class="slds-select"
                            name="newCredential.key"
                            [(ngModel)]="newCredential.key"
                        >
                            <option *ngFor="let option of options" [value]="option">{{option}}</option>
                        </select>
                    </div>
                </div>

                <div class="kd-col slds-size--1-of-2">
                    <div class="slds-form-element">
                        <input
                            class="slds-input"
                            name="newCredential.value"
                            type="text"
                            [(ngModel)]="newCredential.value"
                        />
                    </div>
                </div>
            </div>

            <div class="actions slds-text-align--right">
                <button class="slds-button" (click)="add()">
                    <svg class="slds-button__icon" kdSldsIcon="add"></svg>
                </button>
            </div>
        </div>
    </div>
</kd-slds-modal>
